
import _ from "lodash";
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from 'dayjs/plugin/timezone'
import { BsyUtils } from "./Utils";
dayjs.extend(utc);
dayjs.extend(timezone);

export const dayjsUtils = {
    getNow: function (timezone) {
        if (timezone) {
            const now = dayjs().utc().utcOffset(timezone * 60).format('YYYY-MM-DD HH:mm:ss');
            return dayjs(now);
        }
        return dayjs();
    },
    getYear: function (t) {
        return t.year()
    },
    getMonth: function (t) {
        return t.month()
    },
    getDate: function (t) {
        return t.date()
    },
    getHour: function (t) {
        return t.hour()
    },
    getMinute: function (t) {
        return t.minute()
    },
    getSecond: function (t) {
        return t.second()
    },
    setDate: function (t, e) {
        return t.date(e)
    },
    setHour: function (t, e, r, n) {
        let o = t.hour(e);
        if (!_.isNil(r)) {
            o = o.minute(r)
        }
        if (!_.isNil(n)) {
            o = o.second(n)
        }
        return o
    },
    toDate: function (t) {
        return t.toDate()
    },
    getRealTimeZoneDayjs: function (inputTime, timezone) {
        let r = dayjs(inputTime);
        if (timezone && r.isValid()) {
            let n2 = r.format('YYYY-MM-DD HH:mm:ss');
            return dayjs.tz(n2, timezone)
        }
        return r
    },
    // 把当前时间转换为时区时间
    timeToTZ: function (inputTime) {

        if(typeof inputTime === "string") {
            if (inputTime.match(/^[\d-]+T[\d:.]+Z$/))
                // 如果是utc时间，则转换为本地时间
                inputTime = new Date(inputTime).getTime(); 
            else {
                // 如果是本地时间，则直接返回
                return new Date(inputTime);
            }
        }
        const localDate = new Date(inputTime);  
        const offset = BsyUtils.getSysTimeZoneOffset(); 

        if(typeof offset === "string") {
            return new Date(inputTime);
        }
        const targetOffset = offset * 60; // 相对于utc的偏移
        const currentOffset = new Date().getTimezoneOffset(); // 本地时区偏移（如 UTC+8 = -480）
        const correctTimestamp = localDate.valueOf() + (currentOffset + targetOffset) * 60 * 1000;;
        return new Date(correctTimestamp);
        
        // if (window.localDevInfo.user_corps.timezone &&
        //     window.localDevInfo.user_corps.timezone.value !== "default") {
        //     const n = dayjs(inputTime);
        //     const n2 = n.tz(window.localDevInfo.user_corps.timezone.utc[0]);
        //     const n3 = n2.format('YYYY-MM-DD HH:mm:ss');
        //     return dayjs(n3).toDate();
        // }
        // return dayjs(inputTime).toDate();
    },
    // 根据时区，获取本地时间
    timeToLocal: function (inputTime, format) {

        const localDate = new Date(inputTime);  
        const offset = BsyUtils.getSysTimeZoneOffset(); 
        if(typeof offset === "string") {
            return {
                date: localDate,
                dateStr: BsyUtils.date2Str(localDate, format || 'yyyy-MM-dd HH:mm:ss')
            }
        }
        const targetOffset = offset * 60; // 相对于utc的偏移
        const currentOffset = new Date().getTimezoneOffset(); // 本地时区偏移（如 UTC+8 = -480）
        const correctTimestamp = localDate.valueOf() - (currentOffset + targetOffset) * 60 * 1000;;

        return {
            date: new Date(correctTimestamp),
            dateStr: BsyUtils.date2Str(new Date(localDate), format || 'yyyy-MM-dd HH:mm:ss')
        }

        // if (window.localDevInfo.user_corps.timezone &&
        //     window.localDevInfo.user_corps.timezone.value !== "default") {
        //     let dateobject = dayjsUtils.getRealTimeZoneDayjs(inputTime,
        //         window.localDevInfo.user_corps.timezone.utc[0]);
        //     format = (format || 'YYYY-MM-DD HH:mm:ss')
        //         .replace('yyyy', 'YYYY').replace('dd', 'DD')
        //     return {
        //         date: dateobject.toDate(),
        //         dateStr: dateobject.format(format)
        //     }
        // }
        // const date = new Date(inputTime);
        // return {
        //     date: date,
        //     dateStr: BsyUtils.date2Str(date, format)
        // }
    },
    isDayjs: function (t) {
        return dayjs().isDayjs(t)
    },
    getDay: function (t) {
        return t.day()
    },
    getMillisecond: function (t) {
        return t.millisecond()
    },
    // dayjs: function(t, e) {
    //     _.has
    //     return transTimezone(dayjs(t), e)
    // },
    format: function (t, e) {
        return _.isNil(t) ? "" : t.locale("en").format(e)
    },
    tz: function (t, e) {
        return e ? dayjs().tz(t, e) : dayjs(t)
    },
    isValidate: function (t) {
        return t.isValid()
    },
    valueOf: function (t) {
        return t.valueOf()
    },
    addDate: function (t, e) {
        return t.add(e, "day")
    },
    isBefore: function (t, e, r) {
        return t.isBefore(e, r)
    },
    isSame: function (t, e, r) {
        return t.isSame(e, r)
    },
    startOf: function (t, e) {
        return t.startOf(e)
    }
}

window.bsy_dayjsUtils = dayjsUtils;